import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingParkSubscriptionDialogContentComponent } from './charging-park-subscription-dialog-content/charging-park-subscription-dialog-content.component';

@Component({
  selector: 'app-charging-park-subscription-dialog',
  template: ''
})
export class ChargingParkSubscriptionDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ChargingParkSubscriptionDialogContentComponent, { size: 'lg', centered: true, backdrop: 'static' });

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
